
import { Column, Editing, Item, Lookup, Toolbar } from 'devextreme-react/data-grid';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Card, Button as RxButton } from 'reactstrap';
import Breadcrumb from '../../../components/common/breadcrumb';
import DatagridCustom from '../../../components/common/datagrid/custom-datagrid';
import api from '../../../services/api-configuration';
import useFormatMessage from '../../../utils/useFormatMessage';

export const AdresTanimlari = () => {
    const { t } = useFormatMessage();
    const [dataSources, setDataSources] = useState([]);
    const [city, setCity] = useState([]);
    const [district, setDistrict] = useState([]);


    const ref = useRef();

    useEffect(() => {
        fetchData();
        getCity();
        getDistrict();
    }, []);

    const getCity = async () => {

        try {
            const response = await api.post("/city/getAll");
            setCity(response.data.data || []);
        } catch (error) {
            console.error("Error fetching cities:", error);
            toast.error(t("İller yüklenirken hata oluştu"));
        }
    };

    const getDistrict = async (city) => {

        try {
            const response = await api.post("/district/getAll");
            console.log(response.data.data)
            setDistrict(response.data.data || []);
        } catch (error) {
            console.error("Error fetching districts:", error);
            toast.error(t("İlçeler yüklenirken hata oluştu"));
        }
    };

    const fetchData = async () => {
        try {
            const response = await api.post("/prmAddress/getAll");
            setDataSources(response.data.data || []);
        } catch (error) {
            console.error("Error fetching addresses:", error);
            toast.error(t("Adresler yüklenirken hata oluştu"));
        }
    };

    const handleServerOperation = async (operationType, data, e) => {
        try {
            const employeeId = parseInt(
                Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')
            );

            const payload = {
                ...data,
                ...(operationType === 'create' ? {
                    create_user_id: employeeId,
                    code: ""
                } : {
                    update_user_id: employeeId
                })
            };

            const endpoint = operationType === 'create'
                ? "prmAddress/create"
                : "prmAddress/update";

            const response = await api.post(endpoint, payload);

            if (response.status === 200) {
                // Sunucudan gelen güncel veriyi kullanarak state'i güncelleyin
                const updatedData = response.data.data || payload;

                setDataSources(prevData =>
                    operationType === 'create'
                        ? [...prevData, updatedData]
                        : prevData.map(item =>
                            item.id === updatedData.id ? updatedData : item
                        )
                );

                e.component.saveEditData();
                toast.success(
                    operationType === 'create'
                        ? t("Adres ekleme başarılı")
                        : t("Adres güncelleme başarılı")
                );

                return true;
            }
        } catch (error) {
            console.error(`Error in ${operationType}:`, error);
            const errorMessage = error.response?.data?.error || t("Hata oluştu");
            toast.error(errorMessage);
            return false;
        } finally {
            fetchData();
        }
    };

    const onRowValidating = (e) => {
        if (e.brokenRules.length === 0) {
            const operationType = e.oldData ? 'update' : 'create';
            const data = operationType === 'create'
                ? e.newData
                : { ...e.oldData, ...e.newData };

            // Doğrudan handleServerOperation'ı çağırın
            handleServerOperation(operationType, data, e);
        }
    };
    const districtData = (options) => {

        return {
            store: district,
            filter: options.data ? ["city_id", "=", options.data.city_id] : null,
        }
    }
    return (
        <>
            <Breadcrumb current={t("Adres Tanımları")} />
            <Card className="p-4">
                <DatagridCustom
                    dataSource={dataSources}
                    reff={ref}
                    key={"id"}
                    keyExpr={"id"}
                    onRowValidating={onRowValidating}
                    onInitNewRow={(e) => {
                        e.data.is_active = true;
                        e.component.__addingStart = true;
                    }}
                >
                    <Editing
                        mode="popup"
                        popup={{
                            title: t("Yeni Adres Tanımı"),
                            showTitle: true,
                            width: 800,
                            height: 600,
                        }}
                        allowUpdating
                        allowAdding
                        useIcons
                    />
                    <Column dataField="code" caption={t("Adres Kodu")} alignment='center' selectedFilterOperation='contains' visible={false} />
                    <Column dataField="city_id" caption={t("İl")} alignment='center' selectedFilterOperation='contains'
                        setCellValue={(rowData, value) => {
                            rowData.city_id = value;
                            rowData.district_id = null;

                        }
                        }
                    >
                        <Lookup dataSource={city} valueExpr="id" displayExpr={(c) => (c ? `${c.city_name} (${c.country_code})` : '')} />
                    </Column>
                    <Column dataField="district_id" caption={t("İlçe")} alignment='center' selectedFilterOperation='contains' >
                        <Lookup dataSource={districtData} valueExpr="id" displayExpr="district_name" />
                    </Column>


                    <Column dataField="neighborhood" caption={t("Mahalle")} alignment='center' selectedFilterOperation='contains' />
                    <Column dataField="address" caption={t("Adres")} alignment='center' selectedFilterOperation='contains' />

                    <Column dataField="street" caption={t("Sokak/Cadde")} alignment='center' selectedFilterOperation='contains' />


                    <Column dataField="building_no" caption={t("No")} alignment='center' selectedFilterOperation='contains' />
                    <Column dataField="postal_code" caption={t("Posta Kodu")} alignment='center' selectedFilterOperation='contains' />

                    <Column dataField="is_active" caption={t("Aktif")} dataType="boolean" alignment='center' selectedFilterOperation='contains' />

                    <Toolbar>
                        <Item name="addRowButton" />
                        <Item name="exportButton" />
                        <Item location="after">
                            <RxButton
                                color="light"
                                outline
                                onClick={fetchData}
                                style={{
                                    marginRight: 10,
                                    padding: "0.375rem 0.75rem",
                                    border: "1px solid #c8ced3"
                                }}
                            >
                                <i className="fa fa-refresh"></i>
                            </RxButton>
                        </Item>
                    </Toolbar>
                </DatagridCustom>
            </Card>
        </>
    );
};